var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.496,
    height: 394.305,
    viewBox: "0 0 800.496 394.305",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.484,435.838a1.783,1.783,0,0,1-1.8,1.451H1.775a1.747,1.747,0,0,1-1.748-1.405,1.689,1.689,0,0,1,1.667-1.973H798.817A1.683,1.683,0,0,1,800.484,435.838Z",
    transform: "translate(0 -42.984)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.234,387.232H277.44V76.66a17.391,17.391,0,0,1,17.37-17.37H734.864a17.391,17.391,0,0,1,17.37,17.37V387.232Z",
    transform: "translate(-27.483 -5.873)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 446.865,
    height: 281.093,
    transform: "translate(263.02 74.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.508,433.11H253.73l-32.758-6.235a6.813,6.813,0,0,1-5.532-6.685v-6.91H800.149v7.009a6.832,6.832,0,0,1-5.406,6.658L765.508,433.1Z",
    transform: "translate(-21.341 -40.94)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.237,422.3H494.054a7.611,7.611,0,0,1-7.6-7.6V413.29h96.4V414.7a7.611,7.611,0,0,1-7.6,7.6Z",
    transform: "translate(-48.188 -40.941)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,53.831a20.731,20.731,0,1,1,26.938,19.785L115.019,100.1,94.586,83.075A51.551,51.551,0,0,0,101.37,71.12a20.7,20.7,0,0,1-9.28-17.28Z",
    transform: "translate(-9.122 -3.279)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.748,
    height: 12.748,
    transform: "translate(35.006 357.006) rotate(-143.6)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.568,393.727a4.162,4.162,0,0,1,.333-3.4,5.342,5.342,0,0,1,3.748-2.045c.252-.3,3.442-3.946,4.667-4.117a4.188,4.188,0,0,1,2-2.36,2.149,2.149,0,0,1,1.883.261l.027.018v.036s-.5,4.324,1.919,6.514c1.378,1.252,3.442,1.586,6.126.991.144-.081,2.054-1.811,3.306-2.964l.054-.045,8.694,17.929,6.6,8.415a3,3,0,0,1,.054,3.631,3.034,3.034,0,0,1-2.973,1.171l-5.451-1.036a15.717,15.717,0,0,1-6.334-2.757L21.406,397.889a7.6,7.6,0,0,1-2.856-4.153Z",
    transform: "translate(-1.819 -37.811)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.748,
    height: 12.748,
    transform: "translate(133.06 381.872) rotate(180)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.477,432.71a4.168,4.168,0,0,1-1.748-2.928,5.371,5.371,0,0,1,1.8-3.874c.027-.387.423-5.225,1.315-6.09a4.217,4.217,0,0,1,.216-3.09,2.169,2.169,0,0,1,1.667-.91h.036l.018.027c.018.036,2.171,3.775,5.406,4.1,1.856.189,3.712-.766,5.523-2.838.063-.153.577-2.676.91-4.343V412.7l17.649,9.271,10.307,2.856a3,3,0,0,1,.5,5.595l-5,2.406a15.683,15.683,0,0,1-6.73,1.532h-27.1a7.568,7.568,0,0,1-4.757-1.649Z",
    transform: "translate(-12.751 -40.883)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.592,157.62,79.61,187.036l56.471-.64-8.424-26.875Z",
    transform: "translate(-7.886 -15.614)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.788,189.337l56.336-.034L142.16,391.282H120.646l-13.91-92.148-55.8,73.724L30.57,354.424l40.74-55.291Z",
    transform: "translate(-3.028 -18.753)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.774,231.923l-.432-20.091,11.73-.252.432,20.091a12.319,12.319,0,0,1,3.712,8.766c.135,6.262-3.955,11.433-9.136,11.541s-9.5-4.874-9.631-11.136A12.3,12.3,0,0,1,103.774,231.923Z",
    transform: "translate(-9.95 -20.959)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,81.728l26.118,8.388,11.018,25.217,6,11a12.86,12.86,0,0,1-2.2,15.253l-3.8,3.8,5.307,19.451-49.525-1.766-3.144-44.02a27.677,27.677,0,0,1,1.351-10.739l8.865-26.6Z",
    transform: "translate(-7.885 -8.094)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.208,122.56v97.373H98.838L92.82,123.38",
    transform: "translate(-9.194 -12.141)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.674,80.7s.964,7.343,9.937,7.586l18.19.487s-15.379-37.425-9.054-33.209,23.19-13.46,23.19-13.46l4.973,9.334s11.883-4.306-1.288-14.847c0,0-15.721-12.154-32.407-4.856S84.674,80.7,84.674,80.7Z",
    transform: "translate(-8.364 -2.912)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.871,104.845-.5.03.5-.03l6.37,104.815Z",
    transform: "translate(83.274 102.977)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.41,94.347-.5,0h1L.59,94.346Z",
    transform: "translate(109.924 113.446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.436,218.658H403.246A15.061,15.061,0,0,1,388.2,203.612V15.046A15.061,15.061,0,0,1,403.246,0H655.436a15.061,15.061,0,0,1,15.046,15.046V203.6a15.061,15.061,0,0,1-15.046,15.046Z",
    transform: "translate(-38.455)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.106,8.79a7.136,7.136,0,0,0-7.126,7.126V204.474a7.136,7.136,0,0,0,7.126,7.126H656.3a7.136,7.136,0,0,0,7.126-7.126V15.916A7.136,7.136,0,0,0,656.3,8.79H404.106Z",
    transform: "translate(-39.325 -0.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.939,
    cy: 39.939,
    r: 39.939,
    transform: "translate(486.012 34.884)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.177,73.934a1.543,1.543,0,0,0-.45,2.9l18.361,9.226,1,20.523a1.545,1.545,0,0,0,2.838.766l24.83-38.272a1.546,1.546,0,0,0-1.541-2.369l-45.047,7.208Zm19.631,9.541-14.415-7.244,36.893-5.91-20.343,31.344-.793-16.118,10.748-7a1.237,1.237,0,1,0-1.351-2.072l-10.748,7Z",
    transform: "translate(-54.967 -6.606)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,10.113-.707.707.707-.707,10.113,8.7Z",
    transform: "translate(604.719 16.838)",
    fill: "#ccc9dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.707,10.113-.707,8.7,8.7-.707,10.113.707Z",
    transform: "translate(604.719 16.838)",
    fill: "#ccc9dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.615.75H0V-.75H47.615Z",
    transform: "translate(399.999 99.932)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.259.75H0V-.75H166.259Z",
    transform: "translate(399.999 137.952)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.259.75H0V-.75H166.259Z",
    transform: "translate(399.999 175.971)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.64f41036197c1cf0880056850daa9ca1.svg";
export { ForwardRef as ReactComponent };